export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500 to-accent-600 rounded-2xl p-8 md:p-14 overflow-hidden relative">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-10 right-10 w-40 h-40 rounded-full bg-background-50 blur-3xl"></div>
              <div className="absolute bottom-10 left-10 w-60 h-60 rounded-full bg-background-50 blur-3xl"></div>
            </div>

            <div className="flex-1 relative z-10 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                移动观影 · 随时随地
              </h2>
              <p className="text-sm md:text-base text-background-100/90 leading-relaxed mb-6">
                天美麻花星空影视免费观看全面支持移动端访问。无论您使用手机还是平板，打开浏览器即可畅享电影在线观看、电视剧免费追剧、综艺节目高清播放。无需下载APP，即点即看，高清不缓冲，最新影视一手掌握。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50/20 backdrop-blur-sm rounded-lg border border-background-50/30">
                  <i className="ri-smartphone-line text-background-50 w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm font-medium text-background-50 whitespace-nowrap">手机浏览器访问</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50/20 backdrop-blur-sm rounded-lg border border-background-50/30">
                  <i className="ri-tablet-line text-background-50 w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm font-medium text-background-50 whitespace-nowrap">平板即点即看</span>
                </div>
              </div>
            </div>

            <div className="relative z-10 flex-shrink-0">
              <div className="w-56 md:w-64 aspect-[9/16] rounded-2xl overflow-hidden bg-background-50/10 border-2 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%20and%20warm%20cinematic%20color%20theme%2C%20clean%20minimal%20UI%20design%2C%20dark%20mode%20screens%20with%20golden%20accents%2C%20elegant%20mobile%20entertainment%20app%20aesthetic%2C%20professional%20product%20mockup%20style&width=560&height=996&seq=app-mobile-01&orientation=portrait"
                  alt="天美麻花星空影视免费观看移动端观影界面"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}